import { t } from "i18next";
import * as yup from "yup";

export const aboutUsSchema = yup.object({
  content: yup
    .string()
    .required(t("About us content is required"))
    .min(50, t("About us content cannot have less than 50 symbols."))
});
